import BaseFilters from './BaseFilters';
import { CoreEnums } from '@/utils/domain/constants';

export default {
  ...BaseFilters.RemoteFilter,
  name: 'environmentId',
  label: 'global.text.environment',
  apiRoute: 'environment/paged',
  params: {
    ...BaseFilters.RemoteFilter.params,
    select: 'id,name',
    orderBy: 'name asc',
  },
};
